import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import styles from "./style.module.scss";

interface PublisherResponseProps {
  response: any;
}

function PublisherResponse({ response }: PublisherResponseProps) {
  const [expanded, setExpanded] = useState<boolean>(false);
  const [overflowing, setOverflowing] = useState<boolean>(false);
  const textRef = useRef<HTMLDivElement>(null);

  // The publisher's reply is free text from a textarea, so it can be null,
  // blank, multi-line, in any language, or very long.
  const text =
    typeof response === "string" || typeof response === "number"
      ? String(response).trim()
      : "";

  useEffect(() => {
    setExpanded(false);
  }, [text]);

  useEffect(() => {
    const el = textRef.current;
    // Measure only while collapsed, so "Show less" stays after expanding.
    if (!el || expanded) return;

    const checkOverflow = () =>
      setOverflowing(el.scrollHeight > el.clientHeight + 1);

    checkOverflow();

    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);
    return () => observer.disconnect();
  }, [text, expanded]);

  if (!text) return null;

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeading}>Publisher's Response</div>

      <div
        ref={textRef}
        dir="auto"
        className={classNames(styles.responseText, {
          [styles.collapsed]: !expanded,
          [styles.faded]: !expanded && overflowing,
          [styles.expanded]: expanded,
        })}
      >
        {text}
      </div>

      {overflowing && (
        <button
          type="button"
          className={styles.toggleBtn}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
}

export default PublisherResponse;
